import { render } from "./AltaUsuarioForm.vue?vue&type=template&id=5eb8be92&scoped=true"
import script from "./AltaUsuarioForm.vue?vue&type=script&lang=js"
export * from "./AltaUsuarioForm.vue?vue&type=script&lang=js"

import "./AltaUsuarioForm.vue?vue&type=style&index=0&id=5eb8be92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb8be92"]])

export default __exports__